import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
// import componentsRouter from './modules/components'
// import chartsRouter from './modules/charts'
// import tableRouter from './modules/table'
// import nestedRouter from './modules/nested'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    // 首页
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: { title: '首页', roles: ['admin:index'], icon: 'el-icon-news', affix: true },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: { title: '首页', roles: ['admin:index'], icon: 'el-icon-news', affix: true }
      }
    ]
  },

  // {
  //   // 管理导航
  //   path: '/navigation',
  //   component: Layout,
  //   redirect: '/navigation',
  //   children: [
  //     {
  //       path: 'navigation',
  //       component: () => import('@/views/navigation/index'),
  //       name: 'Navigation',
  //       meta: { title: '管理导航', icon: 'el-icon-position', affix: true }
  //     }
  //   ]
  // },
  {
    // 登录页
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  // {
  //   path: '/auth-redirect',
  //   component: () => import('@/views/login/auth-redirect'),
  //   hidden: true
  // },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  }
  // 404 page must be placed at the end !!!
  // { path: '*', redirect: '/404', hidden: true }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  // 运营管理
  {
    path: '/operation',
    component: Layout,
    redirect: '/',
    name: '运营管理',
    meta: { title: '运营管理', icon: 'el-icon-ship' },
    children: [
      {
        path: '/operation/jobCategory',
        component: () => import('@/views/operation/jobCategory'),
        name: 'jobCategory',
        meta: { title: '工作分类', roles: ['admin:jobCategory'], icon: 'el-icon-notebook-2', affix: false }
      },
      {
        path: '/operation/jobTitle',
        component: () => import('@/views/operation/jobTitle'),
        name: 'jobTitle',
        meta: { title: '工作职位', roles: ['admin:JobTitle'], icon: 'el-icon-c-scale-to-original', affix: false }
      },
      {
        path: '/operation/ad',
        component: () => import('@/views/operation/ad'),
        name: 'ad',
        meta: { title: '广告位管理', roles: ['admin:ad'], icon: 'el-icon-sunrise-1', affix: false }
      }
    ]
  },
  // 企业端管理
  {
    path: '/company',
    component: Layout,
    redirect: '/',
    name: '企业端',
    meta: { title: '企业端', icon: 'el-icon-office-building' },
    children: [
      {
        path: '/company/companyAccount',
        component: () => import('@/views/company/companyAccount'),
        name: 'companyAccount',
        meta: { title: '账号管理', roles: ['admin:companyAccount'], icon: 'el-icon-picture-outline-round', affix: false }
      },
      {
        path: '/company/verifyCompany',
        component: () => import('@/views/company/verifyCompany'),
        name: 'verifyCompany',
        meta: { title: '认证企业', roles: ['admin:company'], icon: 'el-icon-s-check', affix: false }
      },
      {
        path: '/company/jobManagement',
        component: () => import('@/views/company/jobManagement'),
        name: 'jobManagement',
        meta: { title: '职位管理', roles: ['admin:job'], icon: 'el-icon-key', affix: false }
      },
      {
        path: '/company/feedback',
        component: () => import('@/views/company/feedback'),
        name: 'feedback',
        meta: { title: '意见反馈', roles: ['admin:memberFeedback'], icon: 'el-icon-chat-line-round', affix: false }
      }
    ]
  },
  // 用户端管理
  {
    path: '/member',
    component: Layout,
    redirect: '/',
    name: '用户端',
    meta: { title: '用户端', icon: 'el-icon-user-solid' },
    children: [
      {
        path: '/member/member',
        component: () => import('@/views/member/member'),
        name: 'member',
        meta: { title: '用户管理', roles: ['admin:member'], icon: 'el-icon-user', affix: false }
      },
      {
        path: '/member/resumeManagement',
        component: () => import('@/views/member/resumeManagement'),
        name: 'resumeManagement',
        meta: { title: '简历投递管理', roles: ['admin:memberSendResumeRecord'], icon: 'el-icon-printer', affix: false }
      },
      {
        path: '/member/feedback',
        component: () => import('@/views/member/feedback'),
        name: 'feedback',
        meta: { title: '意见反馈', roles: ['admin:companyFeedback'], icon: 'el-icon-chat-line-round', affix: false }
      }
    ]
  },
  // 预支工资
  {
    path: '/advance',
    component: Layout,
    redirect: '/',
    name: '预支工资',
    meta: { title: '预支工资', icon: 'el-icon-user-solid' },
    children: [
      {
        path: '/advance/binding-application',
        component: () => import('@/views/advance/binding-application'),
        name: 'member',
        meta: { title: '绑定公司申请', roles: [], icon: 'el-icon-user', affix: false }
      },
      {
        path: '/advance/onSiteManagement',
        component: () => import('@/views/advance/onSiteManagement'),
        name: 'member',
        meta: { title: '驻场管理', roles: [], icon: 'el-icon-user', affix: false }
      },
      {
        path: '/advance/area',
        component: () => import('@/views/advance/area'),
        name: 'member',
        meta: { title: '区域管理', roles: [], icon: 'el-icon-user', affix: false }
      },
      {
        path: '/advance/bigarea',
        component: () => import('@/views/advance/bigarea'),
        name: 'member',
        meta: { title: '大区域管理', roles: [], icon: 'el-icon-user', affix: false }
      },
      {
        path: '/advance/finance',
        component: () => import('@/views/advance/finance'),
        name: 'member',
        meta: { title: '财务管理', roles: [], icon: 'el-icon-user', affix: false }
      },
      {
        path: '/advance/application-record',
        component: () => import('@/views/advance/application-record'),
        name: 'member',
        meta: { title: '预支申请记录', roles: [], icon: 'el-icon-user', affix: false }
      }
    ]
  },
  // 打卡模块
  {
    path: '/clockIn',
    component: Layout,
    redirect: '/',
    name: '打卡模块',
    meta: { title: '打卡模块', icon: 'el-icon-alarm-clock' },
    children: [
      {
        path: '/clockIn/iTunes',
        component: () => import('@/views/clockIn/iTunes'),
        name: 'member',
        meta: { title: '账号管理', roles: [], icon: 'el-icon-price-tag', affix: false }
      },
      {
        path: '/clockIn/clockInRecord',
        component: () => import('@/views/clockIn/clockInRecord'),
        name: 'member',
        meta: { title: '打卡记录', roles: [], icon: 'el-icon-tickets', affix: false }
      },
      {
        path: '/clockIn/collect',
        component: () => import('@/views/clockIn/collect'),
        name: 'member',
        meta: { title: '打卡汇总', roles: [], icon: 'el-icon-c-scale-to-original', affix: false }
      }
    ]
  },
  // 设置菜单
  {
    path: '/setting',
    component: Layout,
    redirect: '/',
    name: '设置菜单',
    meta: { title: '系统设置', icon: 'el-icon-setting' },
    children: [
      // {
      //   // 城市管理
      //   path: '/setting/cityManagement',
      //   component: () => import('@/views/setting/cityManagement'),
      //   name: 'cityManagement',
      //   meta: { title: '城市管理', roles: ['admin:role'], icon: 'el-icon-postcard' }
      //   // hidden: true
      // },
      {
        // 角色管理
        path: '/setting/role',
        component: () => import('@/views/setting/roleManagement'),
        name: 'RoleManagement',
        meta: { title: '角色管理', roles: ['admin:role'], icon: 'icon-jiaosequanxian', info: '角色权限管理' }
        // hidden: true
      },
      {
        // 管理员管理
        path: '/setting/manangement',
        component: () => import('@/views/setting/management'),
        name: 'Management',
        meta: { title: '管理员管理', roles: ['admin:admin'], icon: 'icon-guanliyuan', info: '后台管理员管理' }
      },
      {
        // 全局变量
        path: '/setting/globalVars',
        component: () => import('@/views/setting/global-vars'),
        name: 'Dashboard',
        meta: { title: '全局变量', roles: ['admin:systemConfig2'], icon: 'el-icon-odometer', affix: false }
      },
      {
        // 内容参数
        path: '/setting/contents',
        component: () => import('@/views/setting/contents'),
        name: 'contents',
        meta: { title: '内容参数', roles: ['admin:systemContent'], icon: 'el-icon-edit-outline', info: '注册协议、关于我们、隐私政策' }
      }
    ]
  }
]

const createRouter = () =>
  new Router({
    mode: 'hash', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
